import { ACKNOWLEDGE_SERVER_ERRORS } from './types';

const acknowledgeServerErrors = () => ({
  type: ACKNOWLEDGE_SERVER_ERRORS,
});

export default acknowledgeServerErrors;
